export const clientLoyaltyBitesLevelFromJSON = (json: IClientLoyaltyBitesLevel): IClientLoyaltyBitesLevelModel => {
	const { threshold_amount, cashback_percentage, ...rest } = json

	return {
		thresholdAmount: threshold_amount,
		cashbackPercentage: cashback_percentage,
		...rest,
	}
}

export const clientLoyaltyBiteStatsFromJSON = (json: IClientLoyaltyBiteStats): IClientLoyaltyBiteStatsModel => {
	const {
		client_id,
		loyalty_level_id,
		current_year_spending,
		level_base_amount,
		first_order_at,
		last_order_at,
		last_level_check_at,
		inactivity_downgrades_count,
		last_inactivity_downgrade_at,
		manual_loyalty_level_id,
		is_manual_level,
		manual_level_set_by_employee_id,
		manual_level_set_at,
		manual_loyalty_level,
		loyalty_levels,
		pending_points,
		current_points,
		six_months_spending,
		amount_to_next_level,
		...rest
	} = json

	return {
		...rest,
		clientId: client_id,
		loyaltyLevelId: loyalty_level_id,
		currentYearSpending: current_year_spending,
		levelBaseAmount: level_base_amount,
		inactivityDowngradesCount: inactivity_downgrades_count,
		manualLoyaltyLevelId: manual_loyalty_level_id,
		isManualLevel: is_manual_level,
		manualLevelSetByEmployeeId: manual_level_set_by_employee_id,
		manualLoyaltyLevel: manual_loyalty_level,
		pendingPoints: pending_points,
		currentPoints: current_points,
		sixMonthsSpending: six_months_spending,
		amountToNextLevel: amount_to_next_level,
		firstOrderAt: first_order_at ? new Date(first_order_at) : null,
		lastOrderAt: last_order_at ? new Date(last_order_at) : null,
		lastLevelCheckAt: last_level_check_at ? new Date(last_level_check_at) : null,
		lastInactivityDowngradeAt: last_inactivity_downgrade_at ? new Date(last_inactivity_downgrade_at) : null,
		manualLevelSetAt: manual_level_set_at ? new Date(manual_level_set_at) : null,
		loyaltyLevels: loyalty_levels.map(clientLoyaltyBitesLevelFromJSON),
	}
}

export const clientLoyaltyBitesTransactionCauserFromJSON = (
	json: IClientLoyaltyBitesTransactionCauser,
): IClientLoyaltyBitesTransactionCauserModel => {
	const { first_name, last_name, phone_number, created_by, is_active, ...rest } = json

	return {
		...rest,
		firstName: first_name,
		lastName: last_name,
		phoneNumber: phone_number,
		createdBy: created_by,
		isActive: is_active,
	}
}

export const clientLoyaltyBitesActivityFromJSON = (
	json: IClientLoyaltyBitesActivity,
): IClientLoyaltyBitesActivityModel => {
	const { starts_at, ends_at, is_active, created_at, updated_at, ...rest } = json

	return {
		...rest,
		startsAt: starts_at ? new Date(starts_at) : null,
		endsAt: ends_at ? new Date(ends_at) : null,
		isActive: is_active,
		createdAt: new Date(created_at),
		updatedAt: new Date(updated_at),
	}
}

export const clientLoyaltyBitesTransactionPointFromJSON = (
	json: IClientLoyaltyBitesTransactionPoint,
): IClientLoyaltyBitesTransactionPointModel => {
	const { current_points, pending_points } = json

	return {
		currentPoints: current_points,
		pendingPoints: pending_points,
	}
}

export const clientLoyaltyBitesTransactionFromJSON = (
	json: IClientLoyaltyBitesTransaction,
): IClientLoyaltyBitesTransactionModel => {
	const {
		loyalty_point_id,
		transactionable_id,
		transactionable_type,
		loyalty_activity_id,
		points_balance,
		created_at,
		updated_at,
		loyalty_activity,
		loyalty_point,
		causer,
		...rest
	} = json

	let parsedCauser = null
	if (typeof causer === 'string') {
		parsedCauser = causer
	} else if (causer) {
		parsedCauser = clientLoyaltyBitesTransactionCauserFromJSON(causer)
	}

	return {
		...rest,
		loyaltyPointId: loyalty_point_id,
		transactionableId: transactionable_id,
		transactionableType: transactionable_type,
		loyaltyActivityId: loyalty_activity_id,
		pointsBalance: points_balance,
		createdAt: new Date(created_at),
		updatedAt: new Date(updated_at),
		loyaltyActivity: loyalty_activity ? clientLoyaltyBitesActivityFromJSON(loyalty_activity) : null,
		loyaltyPoint: loyalty_point ? clientLoyaltyBitesTransactionPointFromJSON(loyalty_point) : null,
		causer: parsedCauser,
	}
}
